import { render, staticRenderFns } from "./aktarimdialog.vue?vue&type=template&id=41fa94ca&"
import script from "./aktarimdialog.vue?vue&type=script&lang=js&"
export * from "./aktarimdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports